<template>
  <div
    :style="`color: ${getColor(foreground_color)}; position: relative;`"
  >
    <LabelOutlined
      :label="label"
      :is_disabled="is_disabled"
      :is_ready="!is_disabled"
      :height="height"
      :width="width + 'px' || '40px'"
      :dark="is_light_mode(getColor(foreground_color))"
      :background_color="getColor(background_color)"
    >
      <template #content>
        <!-- ACTIVE DROPDOWN -->
        <select
          v-if="!is_disabled"
          class="drop-down-outlined-flat-component"
          :style="`color: ${getColor(foreground_color)};`"
          @change="$emit('change', $event.target.value), $event.target.blur()"
        >
          <option
            v-for="(option, index) in options"
            :key="`option${index}-${option}`"
            :value="option.value"
            :selected="value.value === option.value"
            :disabled="option.disabled"
          >
            {{ option.text }} {{option.unit ? `[${option.unit}]` : ''}}
          </option>
        </select>

        <!-- DISABLED STATIC TEXT -->
        <div
          v-else
          class="drop-down-outlined-flat-static-text"
        >
          <span :style="`color: ${getColor(foreground_color)};`">
            {{ value.text }}
          </span>
        </div>
      </template>
    </LabelOutlined>
    <TIcon
      v-if="!is_disabled"
      class="drop-down-outlined-flat-component-arrow"
      :style="`top: ${label ? 14 : 9 }px;`"
      name="menu-down"
    />
  </div>
</template>

<script>
import LabelOutlined from '@/components/WorkPackageWIP/LabelOutlined.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      LabelOutlined,
      TIcon,
    },

    mixins: [
      WorkPackageWIPMixin,
      TColor,
    ],

    props: [
      'label', // is string, label shown in top border
      'selected', // TODO: is currently selected primitive, needed for disabled
      'options', // is array of same typed primitives [{value: , text: , unit: }, ]
      'width', // is number, controls width of dropdown
      'height', // is number, controls height of dropdown
      'is_disabled', // TODO: check this
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is hexcolor, controls border- and font-color
      'value' // selected value
    ],

    data: () => ({

    }),

    methods: {
      test() {
      },
    },
  }
</script>

<style>
  .drop-down-outlined-flat-component {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-size: 11pt;
    font-weight: 300;
    height: 24px;
    width: 100%;
    cursor: pointer !important;  /* TODO: this is not enough */
    outline: none;
  }
  .drop-down-outlined-flat-component-arrow {
    position: absolute;
    right: 0;
    pointer-events: none;
  }
  .drop-down-outlined-flat-component > option {
    color: black;
  }
  .drop-down-outlined-flat-static-text {
    display: flex;
    align-items: center;
    height: 24px;
    margin: 0 4px;
  }
  .drop-down-outlined-flat-static-text > span {
    font-size: 11pt;
    font-weight: 300;
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .drop-down-outlined-flat-select-field:focus {
    outline: none;
  }
</style>
